import React, { useState, useEffect, useContext } from "react";
import AppReactTable from "components/app-react-table";
import { FiSearch } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import AppSearchBar from "components/app-search-bar";
import AppButton from "components/app-button";
import pathnames from "routes/pathnames";
import { IoClose, IoTrashOutline, IoCheckmark } from "react-icons/io5";
import { BiEditAlt } from "react-icons/bi";
// commons
import CONSTANSTS from "common/constansts";
import { PageContext } from "components/app-custom-toast";
import AppCustomToast from "components/app-custom-toast";

const PageMerchantList = () => {
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  // tableSearchFilter are filter payload to be send to backend
  const [tableSearchFilter, setTableSearchFilter] = useState({
    // insert the key value requested by BE here
    pageNo: 1,
    pageSize: 50,
    sortBy: "id",
    sortDir: "DESCENDING",
    dateRangeType: null,
    dateFrom: "",
    dateTo: "",
    keyword: "",
  });

  const [accessDbMerchantList, setAccessDbMerchantList] = useState({
    create_merchant_discovery: false,
    delete_merchant_discovery: false,
    list_merchant_discovery: false,
    merchant_category_list: false,
    update_merchant_discovery: false,
  });

  const [accessDbMerchantDetail, setAccessDbMerchantDetail] = useState(false);

  useEffect(() => {
    setMerchantInput(merchantInputField);
    let dbMerchantAccess = null;
    dbMerchantAccess = JSON.parse(localStorage.getItem("accessMatrix"));
    if (dbMerchantAccess) {
      setAccessDbMerchantList(dbMerchantAccess.accessMatrix.Merchant_Discovery);
      setAccessDbMerchantDetail(
        dbMerchantAccess.accessMatrix.Merchant_Discovery.list_merchant_address
      );
    }
  }, []);

  const headerFilterClick = (header) => {
    let column = header.column;
    if (tableSearchFilter.sortBy === column.searchFilterValue) {
      if (tableSearchFilter.sortDir === "ASCENDING") {
        setTableSearchFilter({
          ...tableSearchFilter,
          sortBy: column.searchFilterValue,
          sortDir: "DESCENDING",
          pageNo: tableSearchFilter.pageNo,
        });
      } else {
        setTableSearchFilter({
          ...tableSearchFilter,
          sortBy: column.searchFilterValue,
          sortDir: "ASCENDING",
          pageNo: tableSearchFilter.pageNo,
        });
      }
    } else {
      setTableSearchFilter({
        ...tableSearchFilter,
        sortBy: column.searchFilterValue,
        sortDir: "ASCENDING",
        pageNo: tableSearchFilter.pageNo,
      });
    }
  };

  const headerArrowRotate = (active) => {
    const classNames = ["react-table__icon-wrapper"];
    if (active && tableSearchFilter.sortDir === "DESCENDING")
      classNames.push("react-table__icon-wrapper-down");
    if (active) classNames.push("react-table__icon-wrapper--show");
    return classNames.join(" ");
  };

  const tableColumn = [
    {
      id: "merchant_name",
      Header: (header) => {
        return (
          <div
            onClick={() => headerFilterClick(header)}
            className="react-table__header"
          >
            <span className="react-table__header-title">Merchant Name</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "merchantName",
      accessor: "merchant_name",
      minWidth: 250,
    },
    {
      id: "category",
      Header: (header) => {
        return (
          <div
            onClick={() => headerFilterClick(header)}
            className="react-table__header"
          >
            <span className="react-table__header-title">Category</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "category",
      accessor: "category",
      minWidth: 250,
    },
    {
      id: "status",
      Header: (header) => {
        return (
          <div
            onClick={() => headerFilterClick(header)}
            className="react-table__header"
          >
            <span className="react-table__header-title">Status</span>
            <div
              className={headerArrowRotate(
                tableSearchFilter.sortBy === header.column.searchFilterValue
              )}
            >
              <span className="react-table__icon"></span>
            </div>
          </div>
        );
      },
      searchFilterValue: "status",
      accessor: "status",
      minWidth: 160,
      width: 160,
    },
    {
      id: "button",
      Header: () => <span className="react-table__headers-title">View</span>,
      Cell: (row) => {
        return (
          accessDbMerchantDetail && (
            <div onClick={(e) => e.stopPropagation()}>
              <button
                onClick={() => viewPage(row.row.original)}
                className="react-table__search-button"
              >
                <FiSearch size={24} />
              </button>
            </div>
          )
        );
      },
      minWidth: 100,
      width: 100,
    },
    {
      id: "action",
      Header: () => <span className="react-table__headers-title">Action</span>,
      Cell: (row) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            {row.row.original.status == "PENDING_CREATE" ||
            row.row.original.status == "PENDING_DELETE"
              ? accessDbMerchantList.create_merchant_discovery && (
                  <>
                    <button
                      onClick={() => [merchantDiscoveryApproval(row.row.original, true)]}
                      className="react-table__search-button"
                      style={{ marginRight: "3px" }}
                    >
                      <IoCheckmark size={24} />
                    </button>
                    <button
                      onClick={() => [
                        merchantDiscoveryApproval(row.row.original, false),
                      ]}
                      className="react-table__search-button"
                    >
                      <IoClose size={24} />
                    </button>
                  </>
                )
              : accessDbMerchantList.update_merchant_discovery && row.row.original.status == "ACTIVE" && (
                  <>
                    <button
                      onClick={() => [
                        setMerchantEditPopup(true),
                        setMerchantId(row.row.original),
                      ]}
                      className="react-table__search-button"
                      style={{ marginRight: "3px" }}
                    >
                      <BiEditAlt size={24} />
                    </button>
                  </>
                )}
            {row.row.original.status == "ACTIVE"
              ? accessDbMerchantList.delete_merchant_discovery && (
                  <>
                    <button
                      onClick={() => [
                        setCancelMerchantPopup(true),
                        setMerchantId(row.row.original),
                      ]}
                      className="react-table__search-button"
                    >
                      <IoTrashOutline size={24} />
                    </button>
                  </>
                )
              : null}
          </div>
        );
      },
      minWidth: 90,
      width: 90,
    },
  ];

  const nextPage = async () => {
    if (
      appList.currentPageNumber < appList.totalPageNumber &&
      !paginationLocker
    ) {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo + 1,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: tableSearchFilter.dateRangeType,
        dateFrom: tableSearchFilter.dateFrom,
        dateTo: tableSearchFilter.dateTo,
        keyword: tableSearchFilter.keyword,
      });
      setPaginationLocker(true);
    } else if (appList.currentPageNumber === appList.totalPageNumber) {
      setPaginationLocker(false);
    }
  };

  const previousPage = async () => {
    if (appList.currentPageNumber > 1 && !paginationLocker) {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo - 1,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: tableSearchFilter.dateRangeType,
        dateFrom: tableSearchFilter.dateFrom,
        dateTo: tableSearchFilter.dateTo,
        keyword: tableSearchFilter.keyword,
      });
      setPaginationLocker(true);
    } else if (appList.currentPageNumber === 1) {
      setPaginationLocker(false);
    }
  };

  const onKeyUp = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event);
    }
  };

  const onBlur = (e) => {
    setSearchValue(e.target.value);
  };

  const onHandleSearch = () => {
    setTableSearchFilter({
      pageNo: tableSearchFilter.pageNo,
      pageSize: tableSearchFilter.pageSize,
      sortBy: tableSearchFilter.sortBy,
      sortDir: tableSearchFilter.sortDir,
      dateRangeType: selected == "- Select Range -" ? null : selected,
      dateFrom:
        tableSearchFilter.dateFrom != "" ? tableSearchFilter.dateFrom : "",
      dateTo: tableSearchFilter.dateTo != "" ? tableSearchFilter.dateTo : "",
      keyword: searchValue,
    });
  };
  const dateFields = {
    dateRange: null,
    dateFrom: "",
    dateTo: "",
  };

  const inputDateProp = [
    { type: "text", placeholder: "Start Date", value: "" },
    { type: "text", placeholder: "End Date", value: "" },
  ];

  const history = useHistory();

  const viewPage = async (value) => {
    history.push(
      pathnames.pageMerchantDiscoverView.replace(
        ":merchantId",
        value.id.toString()
      )
    );
  };

  const merchantInputField = {
    merchantName: {
      value: "",
      error: "",
    },
    category: {
      value: "",
      error: "",
    },
  };

  const addMerchantInputText = {
    merchantName: {
      placeholder: "Merchant Name",
      required: "Merchant Name is required",
      invalid: "Invalid Merchant Name",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
    category: {
      placeholder: "Category",
      required: "Category is required",
      invalid: "Invalid Category",
      regex: CONSTANSTS.REGEX.checkEmpty,
    },
  };

  const [merchantId, setMerchantId] = useState("");
  const [paginationLocker, setPaginationLocker] = useState(true);
  const [appList, setAppList] = useState(undefined);
  const [searchValue, setSearchValue] = useState("");
  const [cancelMerchantPopup, setCancelMerchantPopup] = useState(false);
  const [merchantEditPopup, setMerchantEditPopup] = useState(false);
  const [categoryList, setCategoryList] = useState(undefined);
  //   const [exportBtn, setExportBtn] = useState("orange");
  const [dateInput, setDateInput] = useState(dateFields);
  const [selected, setSelected] = useState(null);
  const [dateType, setDateType] = useState(inputDateProp);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [merchantInput, setMerchantInput] = useState(merchantInputField);
  const [autoExpanded, setExpanded] = useState({});

  useEffect(() => {
    setMerchantInput({
      merchantName: merchantId.merchant_name , // Set to default value or empty string
      category: merchantId.category ,           // Set to default value or empty string
    });
  }, [merchantId]);

  const [merchantNameValidate, setMerchantNameValidate] =
    useState("app-input-text");
  const [merchantCategoryValidate, setMerchantCategoryValidate] =
    useState("app-input-text");

  const checkEmpty = (name, value) => {
    if (name === "merchantName") {
      if (value === "") {
        setMerchantNameValidate("app-input-text-error");
      } else {
        setMerchantNameValidate("app-input-text");
      }
    }
    if (name === "category") {
      if (value === "") {
        setMerchantCategoryValidate("app-input-text-error");
      } else {
        setMerchantCategoryValidate("app-input-text");
      }
    }
  };

  function PopupMerchantEdit(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <button
              className="pop-up-button"
              style={{ marginRight: "10px" }}
              onClick={() => editMerchant(merchantId)}
            >
              Update
            </button>
            <button
              className="pop-up-button"
              style={{ marginLeft: "10px" }}
              onClick={() => [setMerchantEditPopup(false)]}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  function PopupCreateNewMerchant(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <button
              className="pop-up-button"
              style={{ marginRight: "10px" }}
              onClick={() => createNewMerchant()}
            >
              Add
            </button>
            <button
              className="pop-up-button"
              style={{ marginLeft: "10px" }}
              onClick={() => [setCancelPopUp(false)]}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  function PopupCancelMerchant(props) {
    return props.trigger ? (
      <div className="pop-up">
        <div className="pop-up-data">
          {props.children}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <button
              className="pop-up-button"
              style={{ marginRight: "10px" }}
              onClick={() => deleteMerchant(merchantId)}
            >
              OK
            </button>
            <button
              className="pop-up-button"
              style={{ marginLeft: "10px" }}
              onClick={() => [setCancelMerchantPopup(false)]}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }

  const onHandleCreateMerchantName = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    merchantInput.merchantName = value;
    checkEmpty(name, value);
  };

  const onHandleCreateMerchantCategory = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    merchantInput.category = value;
    checkEmpty(name, value);
  };

  const onHandleEditMerchantName = (newName) => {
    setMerchantId((prev) => ({ ...prev, merchant_name: newName }));
    setMerchantInput((prev) => ({
      ...prev,
      merchantName: { ...prev.merchantName, value: newName },
    }));
  };

  const onHandleEditMerchantCategory = (newName) => {
    setMerchantId((prev) => ({ ...prev, category: newName }));
    setMerchantInput((prev) => ({
      ...prev,
      category: { ...prev.category, value: newName },
    }));
  };

  const onHandleOnChange = (event) => {
    var value = event.currentTarget.value;
    if (value === "- Select Range -") {
      setSelected(null);
      value = null;
    } else {
      setSelected(value);
    }

    setDateType(inputDateProp);
    setMinDate("");
    setMaxDate("");

    setTableSearchFilter({
      pageNo: 1,
      pageSize: tableSearchFilter.pageSize,
      sortBy: tableSearchFilter.sortBy,
      sortDir: tableSearchFilter.sortDir,
      dateRangeType: value,
      dateFrom: "",
      dateTo: "",
      keyword: tableSearchFilter.keyword,
    });
  };

  const onFocusDateStart = () => {
    setDateType([
      {
        type: "date",
        placeholder: dateType[0].placeholder,
        value: dateType[0].value,
      },
      {
        type: "date",
        placeholder: dateType[1].placeholder,
        value: dateType[1].value,
      },
    ]);
  };

  const onFocusDateEnd = () => {
    setDateType([
      {
        type: "date",
        placeholder: dateType[0].placeholder,
        value: dateType[0].value,
      },
      {
        type: "date",
        placeholder: dateType[1].placeholder,
        value: dateType[1].value,
      },
    ]);
  };

  const onChangeDateStart = (event) => {
    dateType[0].value = event.currentTarget.value.toString();
    const value = event.currentTarget.value.toString();
    setMinDate(value);
    let date = value;
    let dateSplit = date.split("-");
    setDateInput({
      dateFrom: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0],
      dateTo: dateInput.dateTo,
    });
    setSelected("- Select Range -");

    if (maxDate !== "") {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: null,
        dateFrom: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0],
        dateTo: dateInput.dateTo,
        keyword: tableSearchFilter.keyword,
      });
    }
  };

  const onChangeDateEnd = (event) => {
    dateType[1].value = event.currentTarget.value.toString();
    const value = event.currentTarget.value.toString();
    setMaxDate(value);
    let date = value;
    let dateSplit = date.split("-");
    setDateInput({
      dateFrom: dateInput.dateFrom,
      dateTo: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0],
    });
    setSelected("- Select Range -");

    if (minDate !== "") {
      setTableSearchFilter({
        pageNo: tableSearchFilter.pageNo,
        pageSize: tableSearchFilter.pageSize,
        sortBy: tableSearchFilter.sortBy,
        sortDir: tableSearchFilter.sortDir,
        dateRangeType: null,
        dateFrom: dateInput.dateFrom,
        dateTo: dateSplit[2] + "/" + dateSplit[1] + "/" + dateSplit[0],
        keyword: tableSearchFilter.keyword,
      });
    }
  };

  const merchantDiscoveryApproval = async (value, isApprove) => {
    console.log("MerchantDiscoveryApproval - param -", value, isApprove);
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.APPROVAL_MERCHANT_DISCOVERY + "?discoveryId=" + value.id + "&isApprove=" + isApprove, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          // setCancelPopUp2(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          fetchData();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

   useEffect(() => {
      if (appList?.data) {
        const autoExpanded = {};
        appList.data.forEach((row, index) => {
          if (row.status === "PENDING_UPDATE") {
            autoExpanded[index] = true;
          }
        });
        // console.log("autoExpanded:", autoExpanded);
        setExpanded(autoExpanded);
      }
    }, [appList]);
  
    const renderRowSubComponent = React.useCallback(
      ({ row }) => {
        const original = row.original;
        // console.log("SubComponent row:", original);
        if (original && original.status === "PENDING_UPDATE") {
          return (
            <div style={{ padding: "0px" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr style={{ color: "red" }}>
                    <td style={{ minWidth: "315px", width:"250px" }}>
                      {original.tempMerchantName}
                    </td>
                    <td style={{ minWidth: "350px", width:"250px" }}>
                    </td>
                    <td style={{ minWidth: "350px", width:"250px" }}>
                      {original.tempCategory}
                    </td>
                    <td style={{ minWidth: "350px", width:"250px" }}>
                    </td>
                    <td style={{ minWidth: "350px", width:"250px" }}>    
                    </td>
                    <td style={{ minWidth: "360px", width:"250px" }}>    
                    </td>
                    <td>
                      <button
                        onClick={() => [
                          merchantDiscoveryApproval(original, true),
                        ]}
                        className="react-table__search-button"
                        style={{ marginRight: "3px" }}
                      >
                        <IoCheckmark size={24} />
                      </button>
                      <button
                        onClick={() => [
                          merchantDiscoveryApproval(original, false),
                        ]}
                        className="react-table__search-button"
                      >
                        <IoClose size={24} />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }
        return null;
      },
      []
    );

  const fetchData = async () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      // let response = fetch("http://49.0.203.50/ivc-app/bo/merchant/api/v1/list", {
      fetch(
        process.env.REACT_APP_API_URL +
          CONSTANSTS.ENDPOINT_PATH.GET_MERCHANT_DISCOVERY_LIST,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            criteria: {
              dateFrom:
                tableSearchFilter.dateFrom == ""
                  ? null
                  : tableSearchFilter.dateFrom,
              dateRangeType: tableSearchFilter.dateRangeType,
              dateTo:
                tableSearchFilter.dateTo == ""
                  ? null
                  : tableSearchFilter.dateTo,
              keyword: tableSearchFilter.keyword,
            },
            pageNumber: tableSearchFilter.pageNo,
            pageSize: tableSearchFilter.pageSize,
            sortDirection: tableSearchFilter.sortDir,
            sortKey: tableSearchFilter.sortBy,
          }),
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let result = json.result;
          setAppList(result);
          setPaginationLocker(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategory = async () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.MERCHANT_CATEGORY_DROPDOWN,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          Authorization: "Bearer " + token,
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        let res = json.result;
        setCategoryList(res);
      });
  };

  const deleteMerchant = async (value) => {
    let id = "";
    id = value.id;
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.MERCHANT_DISCOVERY_DELETE +
        "?id=" +
        id,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setCancelMerchantPopup(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          fetchData();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

  useEffect(() => {
    fetchData();
    fetchCategory();
  }, [tableSearchFilter]);

  const createNewMerchant = () => {
    console.log(merchantInput);
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.MERCHANT_DISCOVERY_CREATE,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          merchantName: merchantInput.merchantName,
          category: merchantInput.category,
        }),
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setCancelPopUp(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          fetchData();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

  const editMerchant = (merchant) => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.MERCHANT_DISCOVERY_UPDATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(
        {
          id : merchant.id,
          merchantName : merchantInput.merchantName,
          category : merchantInput.category
        }
      )
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const items = data;
        if (items.responseCode === 200) {
          setMerchantEditPopup(false);
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message: items.message,
            defaultOnClick: false,
          });
          setMerchantInput({
            merchantName: { value: "" }, 
            category: {value: ""},
          });
          fetchData();
        } else {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: items.message,
            defaultOnClick: false,
          });
        }
      });
  };

  return (
    <div className="page-merchant-list">
      {/* <div className="application-list"> */}
      <div className="fixed-content">
        <div className="top-context">
          <div className="title">Merchant Discovery List</div>
          {/* {accessDbMerchantList.export_merchant_list &&
          <div className="search-button">
            <AppButton colorType={exportBtn} label="Export" onClick={() => exportList(exportBtn)}></AppButton>
          </div>
          } */}
          {accessDbMerchantList.create_merchant_discovery && (
            <div className="search-button" style={{ marginRight: "15px" }}>
              <AppButton
                colorType="orange"
                label="Add New Merchant"
                onClick={() => setCancelPopUp(true)}
              ></AppButton>
            </div>
          )}
          <div className="search-bar">
            <AppSearchBar
              placeholder="Search for..."
              onKeyEnter={onKeyUp}
              onBlur={onBlur}
              onClick={onHandleSearch}
            ></AppSearchBar>
          </div>
          <PopupCreateNewMerchant trigger={cancelPopUp}>
            <div className="popup-container">
              <p className="popup-header">Add New Merchant</p>
              <form className="popup-form">
                <div className="form-row">
                  <label>
                    <span>Merchant Name:</span>
                  </label>
                  <input
                    type="text"
                    autoFocus
                    placeholder={addMerchantInputText.merchantName.placeholder}
                    className={merchantNameValidate}
                    name="merchantName"
                    onChange={onHandleCreateMerchantName}
                  />
                </div>
                <div className="form-row">
                  <label>
                    <span>Category :</span>
                  </label>
                  {categoryList !== undefined ? (
                    <select
                      name="category"
                      id="category"
                      className={merchantCategoryValidate}
                      style={{ width: "280px", height: "50px" }}
                      onChange={onHandleCreateMerchantCategory}
                    >
                      {categoryList
                        .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                        .map((d, i) => (
                          <option value={d.value} key={i}>
                            {d.value}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <select
                      name="state"
                      id="state"
                      className={merchantCategoryValidate}
                      style={{ textAlign: "left" }}
                      onChange={onHandleCreateMerchantCategory}
                    >
                      <option value="">-- Category --</option>
                    </select>
                  )}
                </div>
              </form>
            </div>
          </PopupCreateNewMerchant>
          <PopupMerchantEdit trigger={merchantEditPopup}>
            <div className="popup-container">
              <p className="popup-header">Edit Merchant</p>
              <form className="popup-form">
                <div className="form-row">
                  <label>
                    <span>Merchant Name :</span>
                  </label>
                  <input
                    type="text"
                    autoFocus
                    defaultValue={merchantId.merchant_name}
                    className={merchantNameValidate}
                    name="merchantName"
                    onChange={(e) => onHandleEditMerchantName(e.target.value)}
                  />
                </div>
                <div className="form-row">
                  <label>
                    <span>Category :</span>
                  </label>
                  {categoryList !== undefined ? (
                    <select
                      name="category"
                      id="category"
                      defaultValue={merchantId.category}
                      className={merchantCategoryValidate}
                      style={{ width: "280px", height: "50px" }}
                      onChange={(e) => onHandleEditMerchantCategory(e.target.value)}
                    >
                      {categoryList
                        .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                        .map((d, i) => (
                          <option value={d.value} key={i}>
                            {d.value}
                          </option>
                        ))}
                    </select>
                  ) : (
                    <select
                      name="state"
                      id="state"
                      className={merchantCategoryValidate}
                      style={{ textAlign: "left" }}
                      onChange={(e) => onHandleEditMerchantCategory(e.target.value)}
                    >
                      <option value="">-- Category --</option>
                    </select>
                  )}
                </div>
              </form>
            </div>
          </PopupMerchantEdit>
          <PopupCancelMerchant trigger={cancelMerchantPopup}>
            <div className="pop-up-message">
              <p>Are you sure you want to remove this merchant?</p>
            </div>
          </PopupCancelMerchant>
        </div>
        <select
          className="input-field"
          value={selected}
          onChange={onHandleOnChange}
        >
          <option value="- Select Range -"> - Select Range -</option>
          <option value="LAST_7_DAYS">Last 7 days</option>
          <option value="LAST_14_DAYS">Last 14 days</option>
          <option value="LAST_1_MONTH">Last month</option>
        </select>
        <span style={{ fontFamily: "gotham-bold", fontSize: "18px" }}>
          {" "}
          Custom{" "}
        </span>
        <input
          type={dateType[0].type}
          onFocus={onFocusDateStart}
          id="start"
          placeholder={dateType[0].placeholder}
          className="input-field"
          style={{ marginRight: "10px" }}
          onChange={onChangeDateStart}
          value={dateType[0].value}
          max={maxDate}
        />
        <input
          type={dateType[1].type}
          onFocus={onFocusDateEnd}
          id="end"
          placeholder={dateType[1].placeholder}
          className="input-field"
          onChange={onChangeDateEnd}
          value={dateType[1].value}
          min={minDate}
        />
        <div className="pagination-button">
          {appList !== undefined ? (
            <span>
              {tableSearchFilter.pageNo === 1 && appList.totalCount > 0
                ? tableSearchFilter.pageNo
                : tableSearchFilter.pageNo === 1 && appList.totalCount === 0
                ? appList.totalCount
                : 1 + appList.pageSize * (appList.currentPageNumber - 1)}{" "}
              -{""}{" "}
              {appList.pageSize * (appList.currentPageNumber - 1) +
                appList.currentCount}{" "}
              of {appList.totalCount}{" "}
            </span>
          ) : (
            <></>
          )}
          <button onClick={() => previousPage()}>❮</button>
          <button onClick={() => nextPage()}>❯</button>
        </div>

        <div
          className="page-loan-application-list__react-table-wrapper"
          style={{ marginTop: "10px" }}
        >
          {appList !== undefined && appList.data !== undefined ? (
            <AppReactTable 
            columns={tableColumn} 
            data={appList.data}
            expanded={autoExpanded}
            
            renderRowSubComponent={renderRowSubComponent} 
            />
          ) : (
            <div></div>
          )}
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default PageMerchantList;
